import createInterceptor from './Interceptor';

const baseURL = import.meta.env.VITE_DASHBOARD_API_URL;

const axiosInstance = createInterceptor({
  baseURL,
  withCredentials: true,
});

export default axiosInstance;

export const clearHeaders = () => {
  try {
    axiosInstance.defaults.headers.common = {};
  } catch {
    // If it breaks, we do nothing
  }
};
